import styled from "styled-components";
import {colors} from "utils/colors";

export const Root = styled.div`
  width: 100%;
  min-height: 490px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;

  .ant-tag {
    border-radius: 12px;
  }
  th {
    border-radius: 0 !important;
    color: ${colors.gray[400]} !important;
    font-weight: 500 !important;
  }
  th:nth-child(2) {
    width: 80px;
  }
  th:nth-child(5) {
    width: 100px;
  }
  td {
    color: ${colors.gray[700]} !important;
  }
  td:last-child {
    font-weight: 500;
  }
  .ant-table-placeholder td {
    height: 330px;
    border: 0 !important;
  }
`

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .ant-btn {
    color: ${colors.primary};
    border: 1px solid ${colors.primary};
    border-radius: 15px;
    transition: background-color 400ms ease-in-out, color 400ms ease-in-out;
    &:hover {
      background-color: ${colors.primary} !important;
      color: #fff !important;
      transition: background-color 400ms ease-in-out, color 400ms ease-in-out;
    }
  }
`

export const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: ${colors.gray[700]};
`
